import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getGroups: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.permGrpCd !== undefined || searchParams.userGrpName !== undefined || searchParams.useYn !== undefined) {
			queryStr = utils.objectToQueryString({
				permGrpCd: searchParams.permGrpCd,
				userGrpName: searchParams.userGrpName,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/userGroup/v1/plants/${searchParams.plantCd}/groups` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postGroups: param => {
		return client
			.post(`${BASE_URL}/userGroup/v1/status/${param.status}/plants/${param.plantCd}/groups`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
